import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function ClientTypeIcon({ className }: IconProps) {
  return (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_735)">
        <path
          d="M60.0603 8.63369H12.9393C12.0119 8.63369 11.2832 7.88294 11.2832 6.97761C11.2832 6.07229 12.034 5.32153 12.9393 5.32153H60.0603C60.9656 5.32153 61.7164 6.07229 61.7164 6.97761C61.7164 7.88294 60.9656 8.63369 60.0603 8.63369Z"
          fill="#EAEDF8"
        />
        <path
          d="M36.4999 0C32.8345 0 29.8535 2.98094 29.8535 6.6464V63.7039H43.1242V6.6464C43.1242 2.98094 40.1433 0 36.4999 0Z"
          fill="#EAEDF8"
        />
        <path
          d="M39.8118 6.97769C39.8118 8.81042 38.3324 10.2898 36.4997 10.2898C34.6669 10.2898 33.1875 8.81042 33.1875 6.97769C33.1875 5.14496 34.6669 3.66553 36.4997 3.66553C38.3324 3.66553 39.8118 5.14496 39.8118 6.97769Z"
          fill="#00416B"
        />
        <path
          d="M22.567 43.7868C21.9929 43.7868 21.463 43.4114 21.2863 42.8373L12.2772 11.7472L3.26815 42.8373C3.06943 43.5439 2.31867 43.9414 1.63416 43.7427C0.927562 43.5439 0.530103 42.7932 0.728833 42.0866L10.9965 6.60232C11.1732 6.02821 11.681 5.65283 12.2772 5.65283C12.8734 5.65283 13.3813 6.05029 13.5579 6.60232L23.8477 42.1087C24.0464 42.8153 23.649 43.5439 22.9424 43.7647C22.8099 43.8089 22.6995 43.8089 22.567 43.8089"
          fill="#00C4B3"
        />
        <path
          d="M70.9908 43.7868C70.4167 43.7868 69.8868 43.4114 69.7101 42.8373L60.7011 11.7472L51.692 42.8373C51.4933 43.5439 50.7425 43.9414 50.058 43.7427C49.3514 43.5439 48.9539 42.7932 49.1527 42.0866L59.4424 6.60232C59.597 6.02821 60.1269 5.65283 60.7231 5.65283C61.3193 5.65283 61.8272 6.05029 62.0038 6.60232L72.2936 42.1087C72.4923 42.8153 72.0949 43.5439 71.3883 43.7647C71.2558 43.8089 71.1454 43.8089 71.0129 43.8089"
          fill="#00C4B3"
        />
        <path
          d="M64.0355 6.97769C64.0355 8.81042 62.556 10.2898 60.7233 10.2898C58.8906 10.2898 57.4111 8.81042 57.4111 6.97769C57.4111 5.14496 58.8906 3.66553 60.7233 3.66553C62.556 3.66553 64.0355 5.14496 64.0355 6.97769Z"
          fill="#00416B"
        />
        <path
          d="M15.5892 6.97769C15.5892 8.81042 14.1097 10.2898 12.277 10.2898C10.4443 10.2898 8.96484 8.81042 8.96484 6.97769C8.96484 5.14496 10.4443 3.66553 12.277 3.66553C14.1097 3.66553 15.5892 5.14496 15.5892 6.97769Z"
          fill="#00416B"
        />
        <path
          d="M57.3885 68.3408H15.589C14.3083 68.3408 13.2705 69.3786 13.2705 70.6593C13.2705 71.94 14.3083 72.9778 15.589 72.9778H57.3885C58.6692 72.9778 59.707 71.94 59.707 70.6593C59.707 69.3786 58.6692 68.3408 57.3885 68.3408Z"
          fill="#EAEDF8"
        />
        <path
          d="M49.1083 63.7039H23.8918C22.6111 63.7039 21.5732 64.7417 21.5732 66.0224C21.5732 67.3031 22.6111 68.3409 23.8918 68.3409H49.1083C50.389 68.3409 51.4268 67.3031 51.4268 66.0224C51.4268 64.7417 50.389 63.7039 49.1083 63.7039Z"
          fill="#00C4B3"
        />
        <path
          d="M65.6914 31.2446C64.2561 32.1941 62.5559 32.7903 60.7231 32.7903C58.8904 32.7903 57.1681 32.2162 55.7328 31.2667C52.2219 32.9449 49.6605 36.257 49.1306 40.2537C49.0202 41.0486 49.6605 41.7773 50.4775 41.7773H70.9688C71.7858 41.7773 72.404 41.0707 72.3157 40.2537C71.7858 36.2349 69.2243 32.9228 65.7135 31.2446"
          fill="#00416B"
        />
        <path
          d="M67.0159 23.8034C67.0159 27.2701 64.1895 30.0965 60.7228 30.0965C57.2561 30.0965 54.4297 27.2701 54.4297 23.8034C54.4297 20.3366 57.2561 17.5103 60.7228 17.5103C64.1895 17.5103 67.0159 20.3366 67.0159 23.8034Z"
          fill="#00416B"
        />
        <path
          d="M17.2451 31.2446C15.8098 32.1941 14.1096 32.7903 12.2768 32.7903C10.4441 32.7903 8.7218 32.2162 7.28653 31.2667C3.77564 32.9449 1.21424 36.257 0.68429 40.2537C0.573885 41.0486 1.21424 41.7773 2.03124 41.7773H22.5225C23.3395 41.7773 23.9577 41.0707 23.8694 40.2537C23.3395 36.2349 20.7781 32.9228 17.2672 31.2446"
          fill="#00416B"
        />
        <path
          d="M18.5706 23.8034C18.5706 27.2701 15.7442 30.0965 12.2775 30.0965C8.81075 30.0965 5.98438 27.2701 5.98438 23.8034C5.98438 20.3366 8.81075 17.5103 12.2775 17.5103C15.7442 17.5103 18.5706 20.3366 18.5706 23.8034Z"
          fill="#00416B"
        />
        <path
          d="M23.8917 41.7996H0.662432C0.287054 41.7996 0 42.1087 0 42.462C0 47.5848 4.15124 51.7581 9.29613 51.7581H15.258C20.3808 51.7581 24.5541 47.6069 24.5541 42.462C24.5541 42.0866 24.245 41.7996 23.8917 41.7996Z"
          fill="#00C4B3"
        />
        <path
          d="M72.338 41.7996H49.1087C48.7333 41.7996 48.4463 42.1087 48.4463 42.462C48.4463 47.5848 52.5975 51.7581 57.7424 51.7581H63.7043C68.8271 51.7581 73.0004 47.6069 73.0004 42.462C73.0004 42.0866 72.6913 41.7996 72.338 41.7996Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_735">
          <rect width="73" height="73" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
